export default __webpack_public_path__ + "static/secure-push-577acda5377a4fbfad924f775e404e74.webp";